import { defineMessages } from "react-intl";

const messages = defineMessages({
    noData: {
        id: "general.noData",
    },
    modified: {
        id: "general.modified",
    },
    share: {
        id: "planCard.share",
    },
    start: {
        id: "landing.start",
    },
    created: {
        id: "planCard.created",
    },
    christmasEdition: {
        id: "card.christmasEdition",
    },
    isChildrenSong: {
        id: "meta.opus.isChildrenSong",
    },
    isChurchMusic: {
        id: "meta.opus.isChurchMusic",
    },
    unknownComposer: {
        id: "unknownComposer",
    },
    expiredTimeago: {
        id: "homework.expiredTimeago",
        defaultMessage: "Lejárt {timeago}",
    },
    archived: {
        id: "homework.archived",
    },
});

export default messages;
